export default __webpack_public_path__ + "static/media/conversation-dark.d09bd74c.webp";